(() => {
  const SELECTOR_CHECKBOX = '#cart__receipt';
  const SELECTOR_BODY = '.cart__option__receipt .cart__option__body';

  const sync = (checked) => {
    const body = document.querySelector(SELECTOR_BODY);
    if (!body) return;

    body.classList.toggle('visually-hidden', !checked);

    ['receipt_name', 'receipt_for', 'receipt_email'].forEach((k) => {
      const input = document.querySelector(`[data-cart-key="${k}"]`);
      if (!input) return;
      if (checked) input.setAttribute('required', 'required');
      else input.removeAttribute('required');
    });
  };

  const init = () => {
    const cb = document.querySelector(SELECTOR_CHECKBOX);
    if (cb) sync(cb.checked);

    // イベント委譲：DawnのDOM差し替えでも動く
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLElement)) return;
      if (t.matches(SELECTOR_CHECKBOX)) sync(t.checked);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
